import React from 'react';
import { Route, Switch } from 'react-router-dom';
import { createProduct, editProduct, showProduct } from '~/config/routes';
import List from './List';
import Edit from './Edit';
import Show from './Show';
import New from './New';
import { ProductProvider } from './context';
import Can from '~/contexts/Can';
import NotPermissionPage from '~/pages/NotPermissionPage';

function Product() {
  return (
    <ProductProvider>
      <Switch>
        <Route
          exact
          path={createProduct.spec}
          render={(props) => (
            <>
              <Can I="new" a="Products">
                {() => <New {...props} />}
              </Can>
              <Can not I="new" a="Products">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          exact
          path={editProduct.spec}
          render={(props) => (
            <>
              <Can I="edit" a="Products">
                {() => <Edit {...props} />}
              </Can>
              <Can not I="edit" a="Products">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          exact
          path={showProduct.spec}
          render={(props) => (
            <>
              <Can I="show" a="Products">
                {() => <Show {...props} />}
              </Can>
              <Can not I="show" a="Products">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
        <Route
          render={(props) => (
            <>
              <Can I="list" a="Products">
                {() => <List {...props} />}
              </Can>
              <Can not I="list" a="Products">
                {() => <NotPermissionPage />}
              </Can>
            </>
          )}
        />
      </Switch>
    </ProductProvider>
  );
}
export default Product;
